import { useMemo } from 'react';
import { formatDate, FormatDateType } from '../../../helpers/date';
import Clickable from '../Clickable/Clickable';
import { ClickableAction } from '../Clickable/consts';
import LegacyPicture from '../LegacyPicture/LegacyPicture';
import styles from './Card.module.scss';
import type { CardProps } from './interfaces';

const Card = ({
  image,
  headline,
  text,
  subText,
  tag,
  linkintern,
  date,
}: CardProps) => {
  const formattedDate = useMemo(
    () => date && formatDate(new Date(date), FormatDateType.PressArticle),
    [date]
  );

  return (
    <Clickable actionType={ClickableAction.Linkintern} linkintern={linkintern}>
      <div className={styles.base}>
        {image && (
          <LegacyPicture asset={image} className={styles.image} fitCover />
        )}
        <div className={styles.informations}>
          {tag && <div className={styles.category}>{tag}</div>}
          <div className={styles.headline}>{headline}</div>
          {text && <div className={styles.text}>{text}</div>}
          {subText && <div className={styles.subText}>{subText}</div>}
          {date && <div className={styles.date}>{formattedDate}</div>}
        </div>
      </div>
    </Clickable>
  );
};

export default Card;
